import FlightsCarsPackagesGridContainer from '../../../../components/containers/FlightsCarsPackagesGridContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresFlightsCarsPackagesGrid';

const cmpConfig = {
  name: 'flights-cars-packages-grid',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FlightsCarsPackagesGridContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
